import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel, type Model } from '@patsnap/tahiti-core/common/model';
import type { TranslationOptions } from '../type/translation.type';

export const TranslationOptionModel = Symbol('TranslationOptionModel');

export interface TranslationOptionModel extends Model<TranslationOptions> {}

@injectable()
export class TranslationOptionModelImpl extends AbstractModel<TranslationOptions> implements TranslationOptionModel {
    protected _modelData: TranslationOptions = [];
}
